/**
 * Status of Service (SVR redesign §33.1) — the field engineer's overall outcome
 * for a visit. Mirrors the backend SERVICE_STATUS_LABELS in
 * app/modules/field_service/models.py (canonical key → label). Keep the two in
 * sync. Array form preserves the radio/select display order.
 */
export const SERVICE_STATUS_OPTIONS = [
    { value: 'completed', label: 'Completed' },
    { value: 'incomplete', label: 'Incomplete' },
    { value: 'pending_spares', label: 'Pending for Spares' },
    { value: 'under_observation', label: 'Under Observation' },
    { value: 'working_solution_provided', label: 'Working solution provided' },
];
export const SERVICE_STATUS_LABELS = Object.fromEntries(SERVICE_STATUS_OPTIONS.map((o) => [o.value, o.label]));
/** Human label for a stored status key, or null when unset/unknown (render a dash). */
export function serviceStatusLabel(key) {
    if (!key)
        return null;
    return SERVICE_STATUS_LABELS[key] ?? null;
}
